import { DELETE_DICOM_RECORD } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export default (key: string): Promise<Response> => {
    return fetchWithRefresh(DELETE_DICOM_RECORD(key), { method: 'DELETE' });
};
